import React, { useContext, useEffect, useState, createContext, ContextType} from 'react'
import { IChildren } from '../components/layout/index'

export interface IFiltro {
    titulo?: string
    descricao?: string
}

export interface IFiltroContex {
    children?: any
    filtro?: IFiltro[]
    setFiltro?: (e:any) => void
}

export const FiltroContext = createContext<IFiltroContex>({});

export default function ProviderFiltro(props: IChildren){

    const [filtro, setFiltro] = useState<Object[]>();

    return(
        <FiltroContext.Provider value={{filtro, setFiltro}}>
            {
                props.children
            }
        </FiltroContext.Provider>
    )
}